import { useState } from "react";
import { History, X } from "lucide-react";
import { StudioLayout } from "./StudioLayout";
import { useAssistantChat } from "@/hooks/useAssistantChat";
import { AssistantChat } from "@/components/studio/assistant/AssistantChat";
import { AssistantHistory } from "@/components/studio/assistant/AssistantHistory";

export default function StudioAssistant() {
  const chat = useAssistantChat();
  const [drawer, setDrawer] = useState(false);
  const title = chat.chats.find((c) => c.id === chat.chatId)?.title;

  return (
    <StudioLayout
      title="Assistant"
      subtitle="Devis en quelques questions, conseils métier, textes clients : il garde le fil de chaque conversation."
      action={
        <button type="button" data-testid="assistant-page-history" onClick={() => setDrawer(true)} className="inline-flex min-h-[42px] items-center gap-2 rounded-xl border border-[#E2E7F7] bg-white px-4 text-sm font-semibold text-[#0F2645] hover:bg-[#F6F8FD] lg:hidden">
          <History className="h-4 w-4" /> Conversations
        </button>
      }
    >
      <div data-testid="assistant-page" className="grid gap-4 lg:grid-cols-[280px_1fr]">
        <aside className="hidden overflow-hidden rounded-2xl border border-[#E2E7F7] bg-white lg:block lg:h-[calc(100vh-220px)]">
          <AssistantHistory chat={chat} />
        </aside>
        <section className="flex h-[calc(100vh-240px)] min-h-[480px] flex-col overflow-hidden rounded-2xl border border-[#E2E7F7] bg-white lg:h-[calc(100vh-220px)]">
          {title && <p data-testid="assistant-page-title" className="truncate border-b border-[#E2E7F7] px-4 py-2.5 text-xs font-semibold uppercase tracking-wide text-[#93A0BC]">{title}</p>}
          <AssistantChat chat={chat} />
        </section>
      </div>

      {drawer && (
        <div data-testid="assistant-history-sheet" className="fixed inset-0 z-[60] lg:hidden" role="dialog">
          <div className="absolute inset-0 bg-[#0F2645]/50 backdrop-blur-sm" onClick={() => setDrawer(false)} />
          <div className="absolute bottom-0 left-0 right-0 flex max-h-[80vh] flex-col rounded-t-2xl border-t border-[#E2E7F7] bg-white pb-6" style={{ animation: "devSlideUp .2s ease-out" }}>
            <div className="flex items-center justify-between border-b border-[#E2E7F7] px-5 py-4">
              <p className="font-heading text-base font-bold text-[#0F2645]">Conversations</p>
              <button type="button" data-testid="assistant-history-sheet-close" onClick={() => setDrawer(false)} className="inline-flex h-9 w-9 items-center justify-center rounded-xl text-[#93A0BC] hover:bg-slate-100"><X className="h-4.5 w-4.5" /></button>
            </div>
            <div className="min-h-0 flex-1 overflow-y-auto"><AssistantHistory chat={chat} onPick={() => setDrawer(false)} prefix="assistant-sheet" /></div>
          </div>
        </div>
      )}
    </StudioLayout>
  );
}
